import { AnalyticsEventData, gaApply } from "./init"

function sendEvent(data: AnalyticsEventData): void {
    gaApply(["send", "event", data])
}
function sendPageview(page: string): void {
    gaApply(["send", "pageview", page])
}

export { sendEvent, sendPageview }
